import { Injectable } from '@angular/core';
import { Config } from '../../../../config';

@Injectable()
export class Constants {
  public static serverUrl = Config.serverUrl;
  public static assetsPath = '/assets';

  public static breakpoints = {
    desktop: 1800,
    desktopSm: 1600,
    tablet: 1200,
    tabletSm: 991,
    mobile: 767,
  };

  public static dateFormat = 'DD/MM/YYYY';
}
